import { styled } from "@styles";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 2rem;
`;

export const ListItemLink = styled.a``;

export const FaRight = {
  "position": "absolute",
  "right": "1rem",
  "top": "1rem",
} as React.CSSProperties;

export const ListItemText = styled.label`
  padding-left: 1rem;
  font-size: 0.9rem;
`;